import { FolderableCollectionServiceBase } from './folderable-collection-service-base.service';
import equal from 'Angular/utils/equal/deep-equal';
/**
 * Service that fetches a collection of folderable items.
 */
export class FolderableCollectionLoadOnScrollServiceBase extends FolderableCollectionServiceBase {
    constructor() {
        super();
        this.paginationInfo = null;
        this.scrollableBodyHeight = 0;
        this.scrollableBodyId = '';
    }
    /**
     * Load folderable items.
     *
     * By default, fetches items from the following page.
     * When `paginate` is false, data is fetched with the same parameters.
     */
    loadItems(paginate = false, showLoading = false) {
        if (this.folderableCollection$ === null ||
            (paginate &&
                this.paginationInfo !== null &&
                this.paginationInfo.current_page_num === this.paginationInfo.num_pages))
            return;
        this.showLoading = showLoading;
        this.loading = true;
        // Prevent making unnecessary requests on page load and when the user quickly clicks on column headers.
        if (this.folderableCollectionSubscription !== null)
            this.folderableCollectionSubscription.unsubscribe();
        if (paginate && this.dataParams) {
            this.dataParams.page += 1;
        }
        // When name search is enabled, all matching results are shown in a flat list
        if (this.dataParams?.name) {
            this.dataParams.viewRootFolder = null;
        }
        this.folderableCollectionSubscription = this.folderableCollection$.subscribe({
            next: (viewResponse) => {
                this.items = paginate ? this.items.concat(viewResponse.data.items) : viewResponse.data.items;
                this.viewRootFolder = viewResponse.viewRootFolder;
                this.paginationInfo = viewResponse.data.pagination_info;
                this.userHasNoData = viewResponse.userHasNoData;
                this.viewResponse.next(viewResponse);
                this.loading = false;
                // Default back to not showing the loading symbol
                this.showLoading = false;
                this.setScrollableBodyHeight();
            },
            error: (err) => {
                this.viewResponse.error(err);
                this.items = [];
                this.loading = false;
                // Default back to not showing the loading symbol
                this.showLoading = false;
                this.paginationInfo = null;
                this.userHasNoData = false;
            },
        });
    }
    refreshData(dataParams, forceRefresh = false, showLoading = false) {
        // Validate data params
        const dataParamsChanged = forceRefresh || !equal(this.dataParams, dataParams);
        const dataParamsExist = this.dataParams !== null || dataParams !== undefined;
        if (!dataParamsChanged || !dataParamsExist)
            return;
        if (dataParams !== undefined) {
            this.dataParams = dataParams;
        }
        // When refreshing data, start fetching from the first page.
        this.dataParams.page = 1;
        // If there were no items to render, show the loading symbol.
        this.loadItems(false, this.items.length === 0 ? true : showLoading);
    }
    setScrollableBodyHeight() {
        const scrollableBody = document.getElementById(this.scrollableBodyId);
        const offSetTop = scrollableBody ? scrollableBody.offsetTop : 0;
        this.scrollableBodyHeight = window.innerHeight - offSetTop;
    }
}
